// Degree.jsx

import React, { useState } from "react";
import InfoIcon from "../../../assets/img/i-info-gray-filled-icon.png";
import TextInput from "../TextInput";

const Degree = () => {
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    // Example validation
    if (value.trim() === "") {
      setNameError("Name is required");
    } else {
      setNameError("");
    }
  };
  return (
    <>
      <div className="row p-0 m-0 document h-100 w-100">
        <div className="heading col-12 py-3">
          Degree{" "}
          <span>
            <img
              src={InfoIcon}
              alt="InfoIcon"
              data-bs-toggle="tooltip"
              title="Degree Document"
            />
          </span>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <TextInput
            label="Full Name"
            value={name}
            onChange={handleNameChange}
            error={nameError}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <TextInput
            label="Registration No."
            value={name}
            onChange={handleNameChange}
            error={nameError}
          />
        </div>
      </div>
    </>
  );
};

export default Degree;
